export default "__VITE_ASSET__CdKhU9QY__"